import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { Box } from '@jsmdg/yoshi';
import { usePaybackScrid } from '../hooks/usePaybackScrid';
import { type FooterContext } from '../types';
import { CheckoutFooter } from './CheckoutFooter/CheckoutFooter';
import { FooterLinkList } from './FooterLinkList/FooterLinkList';
import { LinksBlock } from './LinksBlock/LinksBlock';
import { Newsletter } from './Newsletter';
import { PaymentMethods } from './PaymentMethods/PaymentMethods';
import { SocialApps } from './SocialApps/SocialApps';
import { Trustpilot } from './Trustpilot/Trustpilot';
import styles from './Footer.module.scss';

const Footer = (): JSX.Element => {
    const {
        areFrequentSearchTermsAndHelpEnabled,
        areSocialAppsEnabled,
        enabledPaymentMethods,
        isNewsletterEnabled,
        isTrustpilotEnabled,
        locale,
        showCheckoutFooter,
    } = useFragmentContext<FooterContext>();

    usePaybackScrid();

    return (
        <Box isFluid>
            {showCheckoutFooter ? (
                <CheckoutFooter />
            ) : (
                <footer>
                    {isTrustpilotEnabled && <Trustpilot locale={locale} />}
                    {isNewsletterEnabled && <Newsletter />}
                    {areSocialAppsEnabled && <SocialApps />}
                    <div className={classNames('p-3x pb-1x', styles.highlightedBg)}>
                        <FooterLinkList />
                        <PaymentMethods
                            enabledMethods={enabledPaymentMethods}
                            className="justify-content-center"
                        />
                    </div>
                    {areFrequentSearchTermsAndHelpEnabled && <LinksBlock />}
                </footer>
            )}
        </Box>
    );
};

export { Footer };
